const Accept = () => import("./Accept.vue");

export default { Accept }